import { LicenseInfo } from "@mui/x-data-grid-premium";
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");

LicenseInfo.setLicenseKey(
  "1e8a4f2ccf7b45e3f4837138f16aab4aTz0xMzMyMzIsRT0xODIxNjU3NTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI="
);

/**
 * Mounts the app into #root once window._APP_CONFIG is populated.
 */
function mountApp(): void {
  if (container == null) return;
  const root = createRoot(container);
  import("./app").then(({ App }) => {
    root.render(<App />);
  });
}

// env.json is the primary config source; env.js (window._APP_CONFIG, set by the
// <script src="/env.js"> tag in index.html) is the fallback, used only when
// env.json is missing or unparseable.
fetch(`${location.origin}/env.json`)
  .then((response) => response.json())
  .then((json) => {
    window._APP_CONFIG = json;
    mountApp();
  })
  .catch(() => {
    // env.json unavailable — fall back to env.js (window._APP_CONFIG).
    if (window._APP_CONFIG) {
      mountApp();
    }
  });
